/**
 * Wrapper around localStorage that silently handles errors when storage
 * is blocked (e.g. Safari private mode, cookies disabled).
 */
export const safeLocalStorage = {
    getItem: (key: string): string | null => {
        try {
            return localStorage.getItem(key);
        } catch {
            return null;
        }
    },
    setItem: (key: string, value: string): void => {
        try {
            localStorage.setItem(key, value);
        } catch {
            // localStorage blocked (e.g. cookies disabled in browser)
        }
    },
    removeItem: (key: string): void => {
        try {
            localStorage.removeItem(key);
        } catch {
            // localStorage blocked (e.g. cookies disabled in browser)
        }
    },
};
